import { useTheme } from '@mui/material';
import {
  MacBookWindow,
  Section,
  TextFill,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  const theme = useTheme();
  return (
    <>
      <MacBookWindow
        title={
          <>
            Develop your custom <br />
            chatbot with our <br />
            team of AI experts
          </>
        }
        description={
          <>
            Chat assistant <b>powered by AI</b>
          </>
        }
        additionalDescription={<> Streamline your business with AI</>}
        buttonText="Book a free consultation"
        buttonLink="/contact"
        gradient="purple-blue"
      />

      <Section
        sx={{
          margin: theme.spacing(1, 0),
        }}
        width="normal">
        <TextFill
          withoutGlow={theme.utils.isWebkit()}
          styledTextStyle={{
            width: '75%',
          }}>
          Standard chatbots that refer customers to blog posts and articles
          instead of giving them a straightforward answer are a thing of the
          past. If you want your customer satisfaction rate to skyrocket, you
          must deliver what your users and customers expect when reaching out
          through one of your contact channels - a personalized and attentive
          assistant that provides them with the information they need. AI chat
          assistant is the answer to those demands. Regardless of your industry.
        </TextFill>
      </Section>
    </>
  );
};
